namespace Areas.Requests.List {
    "use strict";
    
    export function create() {
        var dialog = new Areas.Dialogs.CreateRequest.CreateRequestDialog(() => {});
    }

    export function viewLink(cellElement:any, cellInfo:any) {
        buildCellContent(cellElement,
            () => { return cellInfo.key; },
            "<a href= '/Requests/View/Index/{placeholder}'>View</a>");
    }

    export function view() {
        gotoSelected("ProjectGrid", "/Requests/View/Index/");
    }

    export function edit() {
        gotoSelected("ProjectGrid", "/Requests/Edit/Index/");
    }

    export function review() {
        gotoSelected("ProjectGrid", "/Requests/Review/Index/");
    }

    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }

        setHistoricalCellBackground(e);
        setStatusCellBackground(e);
    }

    function setHistoricalCellBackground(e) {
        var isHistoricalDataCell = e.column.dataField === "isHistorical";

        if (isHistoricalDataCell) {
            if (e.data.isHistorical) {
                e.cellElement.css("background-color", "#FFA07A");
            }
        }
    }

    function setStatusCellBackground(e) {
        var isStatusDataCell = e.column.dataField === "status";

        if (isStatusDataCell) {
            if (e.data.status === 'Approved') {
                e.cellElement.css('background-color', '#90EE90');
            } else if (e.data.status === 'HOLD') {
                e.cellElement.css('background-color', 'yellow');
            } else if (e.data.status === 'DELETED') {
                e.cellElement.css('background-color', 'red');
            }            
        }
    }

    export function onGridSelectionChanged(e) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            const status: string = e.selectedRowsData[0].status;
            const canBeModified =
                (status !== Constants.ProjectInfoStatus.deleted);

            if (canBeModified) {
                if (isEditable(status)) {
                    enableButton("EditButton");
                } else {
                    disableButton("EditButton");
                }

                if (isReviewable(status)) {
                    enableButton("ReviewButton");
                } else {
                    disableButton("ReviewButton");
                }

                if (isReviewable(status)) {
                    enableButton("CompletedReviewButton");
                } else {
                    disableButton("CompletedReviewButton");
                }
            }
        }
    }

    var tabItems = Areas.createTabsWithSameController("Requests", ["InProcess", "Completed", "Deleted"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

}